module.exports = __webpack_public_path__ + "static/media/Gallery1.d6243a50.jpg";